class projects {
	constructor(config) {
		this.config = Object.assign({
			scope: '.our-service-wrapper'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((it, scope) => {
			$(scope).find('.single-service-card').setEqualHeightsPerRow();
		});
	}
}

export default new projects;